// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { TextFieldProps } from "@insite/mobius/TextField";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    gap: 16,
    offsetCss: css`
        &&&& {
            ${xScreen("lt", "xs")} {
                & > ${GridItemStyle} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            }
        }
    `,
};

customerAddressFormFieldStyles.companyNameGridItem = {
    width: 12,
};

customerAddressFormFieldStyles.phoneGridItem = {
    width: 12,
};
customerAddressFormFieldStyles.emailGridItem = {
    width: 6,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("Username"),
    type: "firstName",
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
    type: "lastName",
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
    type: "comapnyName",
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address1"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Address2"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address3"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address4"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City"),
    type: "city",
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Postal Code"),
    type: "postalCode",
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("Phone"),
    type: "phone",
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email"),
    type: "email",
} as TextFieldProps;
